import React from "react";

const Footer = () => {
  return (
    <div className="text-center py-3 footer">
      &copy; {new Date().getFullYear()} Jason Li
    </div>
  );
};

export default Footer;
